import { pick } from 'lodash'

import { defaultMailingAddress, profileFields } from './constants'
import { setPullCreditModalUser } from '@/client/generalSlice'
import { ApplicationProfile, CreditReport } from '@/types/unlock'
import { shallowObjectCompare } from '@/utils'

export const getCreditReportType = (lastAppCreditReport: CreditReport | null) => {
  if (!lastAppCreditReport) return 'single'
  return lastAppCreditReport.is_joint ? 'joint' : 'single'
}

export const resetApplicants = (applicants, originalApplicants, lastSelectedApplicant) => {
  const newApplicants = [...applicants]
  newApplicants[lastSelectedApplicant] = originalApplicants[lastSelectedApplicant]
  return newApplicants
}

export const getFormattedApplicants = (
  applicants: ApplicationProfile[],
  includeFullName = false
) => {
  return applicants.map((currentApplicant) => {
    if (includeFullName) profileFields.push('full_name')
    const newApplicant: any = {
      ...pick(currentApplicant.profile, profileFields),
      mailing_address: currentApplicant.profile.mailing_address,
      credit_reports: currentApplicant.credit_reports,
      applicationProfileUUID: currentApplicant.uuid,
    }
    newApplicant.social_security_number = newApplicant.social_security_number?.replaceAll('-', '')
    return newApplicant
  })
}

export const handleCasesWithUserModal = (
  applicants,
  selectedApplicant,
  applicant,
  setFieldValue,
  dispatch,
  action,
  single_or_joint
) => {
  if (
    selectedApplicant !== null &&
    selectedApplicant !== undefined &&
    applicants[selectedApplicant].uuid === applicant.profile.uuid &&
    single_or_joint === 'joint' &&
    !!action
  ) {
    setFieldValue('selectedApplicant', null)
  }
  if (
    selectedApplicant !== null &&
    selectedApplicant !== undefined &&
    applicants[selectedApplicant].uuid === applicant.profile.uuid &&
    action === 'unmerge'
  ) {
    setFieldValue('selectedApplicant', null)
  }
  if (!!action && !!single_or_joint) {
    setFieldValue(
      'mailing_address',
      applicants[selectedApplicant]?.mailing_address ?? defaultMailingAddress
    )
    dispatch(setPullCreditModalUser(''))
  }
}

export const checkMailingAddress = (single_or_joint, initialValues, values) => {
  if (single_or_joint === 'joint') {
    return (
      initialValues.applicants[0].mailing_address === null ||
      !shallowObjectCompare(initialValues.applicants[0].mailing_address, values.mailing_address)
    )
  }
  return (
    initialValues.applicants[values.selectedApplicant].mailing_address === null ||
    !shallowObjectCompare(
      initialValues.applicants[values.selectedApplicant].mailing_address,
      values.mailing_address
    )
  )
}

export function getCoApplicant(
  applicantIndex,
  applicants,
  creditReportOptions,
  latestCreditReport
) {
  if (latestCreditReport && !latestCreditReport.is_joint) return applicantIndex
  if (applicantIndex !== 0) return applicantIndex
  const creditReport = creditReportOptions.find(
    (report) => report.value === latestCreditReport.file_number
  )
  let coApplicantIndex = null
  if (creditReport) {
    for (let i = 0; i < creditReport.applicants.length; i++) {
      if (creditReport.applicants[i].uuid !== applicants[0].applicationProfileUUID) {
        coApplicantIndex = i
        break
      }
    }
  }
  return coApplicantIndex
}
